(function (global) {
  // ============================================================
  // MONTH + DELIVERY DATE PLACEHOLDER REPLACER
  // ============================================================
  // Replaces inside all elements with the configured class:
  //   [[current_month]], [[next_month]], [[previous_month]]
  //   [[expected_delivery]]  → e.g. "Tuesday, 26 May"
  //
  // Usage:
  //   MonthReplace.init("bg");
  //   MonthReplace.init({ language: "de", deliveryDays: 7 });
  // ============================================================

  var MONTHS = {
    en: ['January','February','March','April','May','June','July','August','September','October','November','December'],
    bg: ['Януари','Февруари','Март','Април','Май','Юни','Юли','Август','Септември','Октомври','Ноември','Декември'],
    de: ['Januar','Februar','März','April','Mai','Juni','Juli','August','September','Oktober','November','Dezember'],
    ro: ['Ianuarie','Februarie','Martie','Aprilie','Mai','Iunie','Iulie','August','Septembrie','Octombrie','Noiembrie','Decembrie'],
    es: ['Enero','Febrero','Marzo','Abril','Mayo','Junio','Julio','Agosto','Septiembre','Octubre','Noviembre','Diciembre'],
    fr: ['Janvier','Février','Mars','Avril','Mai','Juin','Juillet','Août','Septembre','Octobre','Novembre','Décembre'],
    it: ['Gennaio','Febbraio','Marzo','Aprile','Maggio','Giugno','Luglio','Agosto','Settembre','Ottobre','Novembre','Dicembre'],
    cs: ['Leden','Únor','Březen','Duben','Květen','Červen','Červenec','Srpen','Září','Říjen','Listopad','Prosinec'],
    pl: ['Styczeń','Luty','Marzec','Kwiecień','Maj','Czerwiec','Lipiec','Sierpień','Wrzesień','Październik','Listopad','Grudzień'],
    sk: ['Január','Február','Marec','Apríl','Máj','Jún','Júl','August','September','Október','November','December']
  };
  
  // Weekdays: index 0 = Sunday ... index 6 = Saturday (matches Date.getDay())
  var WEEKDAYS = {
    en: ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'],
    bg: ['Неделя','Понеделник','Вторник','Сряда','Четвъртък','Петък','Събота'],
    de: ['Sonntag','Montag','Dienstag','Mittwoch','Donnerstag','Freitag','Samstag'],
    ro: ['Duminică','Luni','Marți','Miercuri','Joi','Vineri','Sâmbătă'],
    es: ['Domingo','Lunes','Martes','Miércoles','Jueves','Viernes','Sábado'],
    fr: ['Dimanche','Lundi','Mardi','Mercredi','Jeudi','Vendredi','Samedi'],
    it: ['Domenica','Lunedì','Martedì','Mercoledì','Giovedì','Venerdì','Sabato'],
    cs: ['Neděle','Pondělí','Úterý','Středa','Čtvrtek','Pátek','Sobota'],
    pl: ['Niedziela','Poniedziałek','Wtorek','Środa','Czwartek','Piątek','Sobota'],
    sk: ['Nedeľa','Pondelok','Utorok','Streda','Štvrtok','Piatok','Sobota']
  };

  var DEFAULTS = {
    targetClass:    'month-replace',
    language:       'en',
    deliveryDays:   5,
    deliveryFormat: 'weekday-day-month' // 'weekday-day-month' | 'day-month' | 'day-month-year' | 'numeric'
  };

  function addWorkingDays(date, days) {
    var d = new Date(date.getTime());
    var added = 0;
    while (added < days) {
      d.setDate(d.getDate() + 1);
      var dow = d.getDay(); // 0 = Sun, 6 = Sat
      if (dow !== 0 && dow !== 6) {
        added++;
      }
    }
    return d;
  }

  function formatDeliveryDate(d, months, weekdays, format) {
    var weekday = weekdays[d.getDay()];
    var day     = d.getDate();
    var month   = months[d.getMonth()];
    var year    = d.getFullYear();

    switch (format) {
      case 'day-month':
        return day + ' ' + month;
      case 'day-month-year':
        return day + ' ' + month + ' ' + year;
      case 'numeric':
        var dd = (day < 10 ? '0' : '') + day;
        var mm = ((d.getMonth() + 1) < 10 ? '0' : '') + (d.getMonth() + 1);
        return dd + '.' + mm + '.' + year;
      case 'weekday-day-month':
      default:
        return weekday + ', ' + day + ' ' + month;
    }
  }

  function buildValues(config) {
    var months   = MONTHS[config.language]   || MONTHS.en;
    var weekdays = WEEKDAYS[config.language] || WEEKDAYS.en;

    var now           = new Date();
    var currentIndex  = now.getMonth();
    var previousIndex = (currentIndex + 11) % 12;
    var nextIndex     = (currentIndex + 1)  % 12;

    var deliveryDate = addWorkingDays(now, config.deliveryDays);

    return {
      current_month:     months[currentIndex],
      previous_month:    months[previousIndex],
      next_month:        months[nextIndex],
      expected_delivery: formatDeliveryDate(deliveryDate, months, weekdays, config.deliveryFormat)
    };
  }

  function replaceInElement(el, values) {
    var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null);
    var node;
    while ((node = walker.nextNode())) {
      var text = node.nodeValue;
      if (text.indexOf('[[') === -1) continue;
      node.nodeValue = text.replace(/\[\[(current_month|next_month|previous_month|expected_delivery)\]\]/g, function (_, key) {
        return values[key];
      });
    }
  }

  function normalizeOptions(opts) {
    var config = {
      targetClass:    DEFAULTS.targetClass,
      language:       DEFAULTS.language,
      deliveryDays:   DEFAULTS.deliveryDays,
      deliveryFormat: DEFAULTS.deliveryFormat
    };

    if (typeof opts === 'string') {
      config.language = opts;
    } else if (opts && typeof opts === 'object') {
      if (opts.targetClass)    config.targetClass    = opts.targetClass;
      if (opts.language)       config.language       = opts.language;
      if (opts.deliveryDays != null) config.deliveryDays = opts.deliveryDays;
      if (opts.deliveryFormat) config.deliveryFormat = opts.deliveryFormat;
    }

    return config;
  }

  function run(config) {
    var values = buildValues(config);
    var elements = document.getElementsByClassName(config.targetClass);
    Array.prototype.slice.call(elements).forEach(function (el) {
      replaceInElement(el, values);
    });
  }

  var MonthReplace = {
    init: function (opts) {
      var config = normalizeOptions(opts);

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function () { run(config); });
      } else {
        run(config);
      }
    }
  };

  global.MonthReplace = MonthReplace;
})(window);